import * as React from "react";

function Logo(props: React.SVGProps<SVGSVGElement>) {
	return (
		<svg
			width="48"
			height="48"
			viewBox="0 0 48 48"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			{...props}
		>
			<path
				d="M41 10C46 14 48 19.4 48 24.3V30C48 36.5 46 40 43 42 36.8 45 30.3 39 21.5 43 16.7 45 5 50.8.8 44 .2 43 0 42 0 41V34.5C-.1 27 9 17 14 13 21 8 31.5 3 41 10Z"
				fill="grey"
			/>
			<path
				d="M14.1387 13.2972C20.9725 8.13871 31.4601 2.7969 41.2271 10.2249C50.7475 17.4631 49.1481 31.8323 43.0793 34.5885C36.7703 37.4523 30.2779 31.3645 21.4845 35.4672C16.7496 37.6798 5.16198 43.2744 0.78107 36.3965C-3.08146 30.3341 8.41763 17.6148 14.1387 13.2972Z"
				fill="grey"
			/>
			<path
				d="M31.7571 25.0112C31.4474 25.2009 31.0491 25.3526 30.5561 25.46C30.0694 25.5738 29.5003 25.6307 28.8555 25.6307C27.9958 25.6307 27.2878 25.5548 26.7252 25.3969C26.1625 25.2388 25.8022 24.9733 25.6315 24.594C24.9614 23.0831 24.4178 21.8567 23.9879 20.9148C23.558 19.9728 23.2229 19.1573 22.9827 18.4493H22.8058C22.7362 19.4671 22.6793 20.3901 22.6414 21.2246C22.6034 22.059 22.5845 22.8745 22.5718 23.6647C22.5592 24.4549 22.5339 25.2578 22.5023 26.067C22.4643 26.8761 22.4138 27.7675 22.3379 28.7473C22.0282 28.8358 21.6236 28.9053 21.1242 28.9686C20.6247 29.0255 20.119 29.0571 19.6196 29.0571C18.5702 29.0571 17.7484 28.9369 17.1668 28.6967C16.5789 28.4565 16.2881 28.0203 16.2881 27.3818L17.3248 14.2201C17.5145 13.9989 17.9318 13.7587 18.5765 13.4995C19.2213 13.2403 20.1317 13.1139 21.3011 13.1139C22.5655 13.1139 23.558 13.2529 24.2724 13.5374C24.9867 13.8219 25.5114 14.2834 25.8465 14.9155C26.0614 15.3264 26.2952 15.8006 26.5418 16.3379C26.7947 16.8689 27.0412 17.4189 27.2941 17.9879C27.547 18.5568 27.7871 19.1194 28.0274 19.6758C28.2677 20.2384 28.4826 20.7377 28.6722 21.1866H28.8492C29.4245 19.739 29.9935 18.3418 30.5687 16.9954C31.144 15.6425 31.6687 14.5173 32.1428 13.6006C32.5032 13.4615 32.9583 13.3478 33.5209 13.2529C34.0836 13.1581 34.7094 13.1139 35.4048 13.1139C36.5742 13.1139 37.5288 13.2403 38.2685 13.4868C39.0081 13.7397 39.438 14.0937 39.5581 14.5552C39.653 14.8966 39.7541 15.4276 39.8615 16.1419C39.969 16.8563 40.0828 17.6591 40.2029 18.5568C40.3231 19.4482 40.4432 20.3964 40.557 21.3953C40.677 22.394 40.7908 23.3486 40.8983 24.2716C41.0058 25.1882 41.0943 26.0353 41.1638 26.8003C41.2334 27.5652 41.284 28.1531 41.3093 28.5703C40.9046 28.741 40.4811 28.8674 40.0385 28.9433C39.5961 29.0191 39.0271 29.0571 38.338 29.0571C37.4277 29.0571 36.6691 28.9433 36.0433 28.722C35.4238 28.5008 35.0887 28.0582 35.0381 27.4071C34.8928 25.5296 34.8043 23.8481 34.7663 22.3498C34.7284 20.8515 34.6778 19.5999 34.6083 18.5821H34.4312C34.191 19.2522 33.8433 20.0929 33.3945 21.1108C32.9457 22.1286 32.402 23.4308 31.7571 25.0112Z"
				fill="white"
			/>
			<path
				d="M31.8 10.7C31.5 9 35.2 6.4 38.8 6.3 39 6.3 42.5 6 43 7.5 43.5 8.9 41 11.4 38.3 12.2 35.6 12.9 32.1 12.1 31.8 10.7Z"
				fill="grey"
			/>
			<path
				d="M32 11C30.6 10.1 31.3 5.6 33.8 2.9 33.9 2.8 36.2.2 37.5.9 38.9 1.5 38.9 5 37.6 7.4 36.2 9.9 33.2 11.8 32 11Z"
				fill="grey"
			/>
		</svg>
	);
}

const MemoLogo = React.memo(Logo);
export default MemoLogo;
